// extracted by mini-css-extract-plugin
module.exports = {"externalLayout":"externalLayout--3ArDN"};